import { Stack } from '@mantine/core';

import { CollapsableBook } from '@/module/AnnualReport/items/collapsable/CollapsableBook';
import { CollapsableChapter } from '@/module/AnnualReport/items/collapsable/CollapsableChapter';
import { CollapsableCourse } from '@/module/AnnualReport/items/collapsable/CollapsableCourse';
import { AnnualReportTexts } from '@/module/AnnualReport/model/AnnualReportTypes';

interface AnnualTextsOverviewProps {
  texts: AnnualReportTexts;
}

export function AnnualTextsOverview({ texts: { books, chapters, courses } }: AnnualTextsOverviewProps) {
  return (
    <Stack gap="xl">
      <CollapsableBook
        title="Cărți apărute în edituri internaționale"
        books={books.internationalBooks}
      />
      <CollapsableBook
        title="Cărți apărute în edituri naționale, recunoscute CNCS"
        books={books.cncsBooks}
      />
      <CollapsableChapter
        title="Capitole în cărți apărute în edituri internaționale"
        chapters={chapters.internationalChapters}
      />
      <CollapsableChapter
        title="Capitole în cărți apărute în edituri naționale, recunoscute CNCS"
        chapters={chapters.cncsChapters}
      />
      <CollapsableCourse
        title="Cursuri, îndrumătoare de lucrări practice/seminarii"
        courses={courses.courses}
      />
    </Stack>
  );
}
